(function () {
  'use strict';
  var root = document.querySelector('[data-nrc-consent]');
  if (!root) return;

  var KEY = 'nrc-consent-v1';
  var designMode = root.hasAttribute('data-design-mode');
  var main = root.querySelector('[data-nrc-consent-main]');
  var panel = root.querySelector('[data-nrc-consent-panel]');
  var panelTitle = root.querySelector('[data-nrc-consent-panel-title]');
  var customizeBtn = root.querySelector('[data-nrc-consent-customize]');
  var toggles = {};
  root.querySelectorAll('[data-nrc-consent-toggle]').forEach(function (el) {
    toggles[el.getAttribute('data-nrc-consent-toggle')] = el;
  });
  var lastOpener = null;

  function readLocal() {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; }
  }
  function writeLocal(prefs) {
    try { localStorage.setItem(KEY, JSON.stringify(prefs)); } catch (e) {}
  }

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
      ? window.Shopify.customerPrivacy : null;
  }

  function loadApi(cb) {
    if (privacyApi()) return cb(privacyApi());
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          cb(err ? null : privacyApi());
        });
        return;
      } catch (e) {}
    }
    cb(null);
  }

  function pushToGoogle(prefs) {
    try {
      window.dataLayer = window.dataLayer || [];
      var state = {
        analytics_storage: prefs.analytics ? 'granted' : 'denied',
        ad_storage: prefs.marketing ? 'granted' : 'denied',
        ad_user_data: prefs.marketing ? 'granted' : 'denied',
        ad_personalization: prefs.marketing ? 'granted' : 'denied',
        functionality_storage: prefs.preferences ? 'granted' : 'denied'
      };
      if (typeof window.gtag === 'function') window.gtag('consent', 'update', state);
      window.dataLayer.push({ event: 'nrc_consent_update', nrc_consent: prefs });
    } catch (e) {}
  }

  function save(prefs) {
    writeLocal(prefs);
    pushToGoogle(prefs);
    loadApi(function (api) {
      if (!api) return;
      try {
        api.setTrackingConsent({
          analytics: !!prefs.analytics,
          marketing: !!prefs.marketing,
          preferences: !!prefs.preferences,
          sale_of_data: !!prefs.marketing
        }, function () {});
      } catch (e) {}
    });
    close();
  }

  function fillToggles(prefs) {
    Object.keys(toggles).forEach(function (k) { toggles[k].checked = !!(prefs && prefs[k]); });
  }
  function readToggles() {
    var p = {};
    Object.keys(toggles).forEach(function (k) { p[k] = toggles[k].checked; });
    return p;
  }

  function showPanel(show) {
    panel.hidden = !show;
    main.hidden = show;
    customizeBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show) panelTitle.focus();
    else customizeBtn.focus();
  }

  function open(startWithPanel) {
    fillToggles(readLocal());
    root.hidden = false;
    main.hidden = !!startWithPanel;
    panel.hidden = !startWithPanel;
    if (startWithPanel) panelTitle.focus();
  }

  function close() {
    root.hidden = true;
    if (lastOpener && document.body.contains(lastOpener)) { try { lastOpener.focus(); } catch (e) {} }
    lastOpener = null;
  }

  root.querySelector('[data-nrc-consent-accept]').addEventListener('click', function () {
    save({ analytics: true, marketing: true, preferences: true });
  });
  root.querySelector('[data-nrc-consent-reject]').addEventListener('click', function () {
    save({ analytics: false, marketing: false, preferences: false });
  });
  customizeBtn.addEventListener('click', function () { showPanel(true); });
  root.querySelector('[data-nrc-consent-back]').addEventListener('click', function () { showPanel(false); });
  root.querySelector('[data-nrc-consent-save]').addEventListener('click', function () { save(readToggles()); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden && !panel.hidden) showPanel(false);
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-nrc-cookie-open]') : null;
    if (!t) return;
    e.preventDefault();
    lastOpener = t;
    open(true);
  });

  function alreadyDecided(api) {
    if (readLocal()) return true;
    if (api && typeof api.currentVisitorConsent === 'function') {
      var c = api.currentVisitorConsent() || {};
      return ['analytics', 'marketing', 'preferences'].some(function (k) { return c[k] === 'yes' || c[k] === 'no'; });
    }
    return false;
  }

  // Na prévia da Shopify existe uma barra fixa na base da tela: sobe o banner para não ficar coberto.
  function adjustForPreviewBar() {
    try {
      var els = document.querySelectorAll('body > *, html > *');
      var best = 0;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el === root || el.contains(root) || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'HEAD' || el.tagName === 'BODY') continue;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
        var r = el.getBoundingClientRect();
        if (r.height > 20 && r.height < 140 && r.width > window.innerWidth * 0.5 && r.bottom >= window.innerHeight - 2 && r.top > window.innerHeight / 2) {
          best = Math.max(best, r.height);
        }
      }
      root.style.bottom = best ? (best + 8) + 'px' : '';
    } catch (e) {}
  }

  function init() {
    adjustForPreviewBar();
    var adjTries = 0;
    var adjTimer = setInterval(function () { adjustForPreviewBar(); if (++adjTries > 20) clearInterval(adjTimer); }, 500);
    if (designMode) { open(false); return; }
    loadApi(function (api) {
      if (alreadyDecided(api)) return;
      setTimeout(function () { open(false); }, 600);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
